import React from 'react'
import styled from 'styled-components'

import logo from '../assets/images/logo.png'

interface IProps {
  children: React.ReactNode
}

export default function Main({ children }: IProps) {
  return (
    <Container>
      <img alt="" src={logo} />
      <GradientText>Score Counter</GradientText>
      {children}
    </Container>
  )
}

const Container = styled.main`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 16px;
  width: 100%;

  & > img {
    height: auto;
    width: 800px;

    @media screen and (max-width: 824px) {
      width: 260px;
    }
  }
`

const GradientText = styled.p`
  font-size: 48px;
  font-weight: bold;
  color: transparent;
  background: linear-gradient(180deg, #f6d967, #c4272b);
  background-clip: text;
  display: inline-block;
  margin-bottom: 16px;
  position: relative;
  text-align: center;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke: 1px #ffffff;

  @media screen and (max-width: 824px) {
    font-size: 28px;
  }
`
